import React from "react"
import { GetTable } from "../../common/components/DataTable"
import { TipoContratto } from "../../generated"
import { Link } from "../../common/components/link";
import { links } from "../../routes";
import Store from "../tipiContrattoStore";
import { Loading } from "../../common/components/loading";

const Table = GetTable<TipoContratto>();
export default () => {
    const data = Store.useAll()
    if (!data)
        return <Loading />
    return <div className="card">
        <div className="card-header bg-theme" style={{ display: "flex" }}>
            <h3 className="flex-fill text-white">Tipi Contratto</h3>
            <Link to={links.tipoContrattoNew} className="btn btn-outline-secondary"><i className="fas fa-plus" /> Nuovo</Link>
        </div>
        <div className="card-body">
            <Table
                data={data}
                keySelector={x => x.id}
                filterables={[x => x.descrizione]}
            >
                <Table.Column template={x => <Link to={links.tipoContrattoEdit(x.id)}>{x.descrizione}</Link>} header="Descrizione" />
                <Table.Column template={x => x.mesiValidita} header="Mesi Validità" />
            </Table>
        </div>
    </div>

};